module.exports = __webpack_public_path__ + "static/img/comunidado_RPA.1ce942f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunidado_RPA.jpg
// module id = 08QF
// module chunks = 9